import { render, staticRenderFns } from "./SiatPraticheSceltaListPage.vue?vue&type=template&id=3e54c378"
import script from "./SiatPraticheSceltaListPage.vue?vue&type=script&lang=js"
export * from "./SiatPraticheSceltaListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports